import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { Navigation } from '@pkg/components/Navigation';
import YatHandLoader from '@pkg/components/loaders/YatHandLoader';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';
import { useSearchParamsState } from '@pkg/hooks/navigation/useSearchParams';
import { type EmojiId, YatPageVersion } from '@pkg/types';

import { getYatPageDetails } from '@app/store/actions/yat-page';
import { useProfileMetadataStore } from '@app/store/zustand/profile-page/useProfileMetadataStore';

import { NoYatsError } from './components';
import { useGetYatPageProfile } from './hooks';

export function ProfileRedirect() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const emojiID = useAppSelector((state) => state.user.userAccount?.user.eid);
    const { params } = useSearchParamsState<{ yat?: EmojiId }>();
    const { setPageVersion, setEmojiId } = useProfileMetadataStore();
    const { data, isLoading } = useGetYatPageProfile();

    useEffect(() => {
        try {
            const emoji = data?.eid || emojiID;

            if (emoji) {
                setEmojiId(emoji);

                dispatch(getYatPageDetails(emoji)).then(async (r) => {
                    if (r?.ok) {
                        setPageVersion(r.value.version);
                    } else {
                        setPageVersion(YatPageVersion.NOT_FOUND);
                    }
                });

                if (params.yat) {
                    // navigate(`/${emoji}/yats?yat=${params.yat}`);
                    navigate(`/${emoji}/yats`);
                } else {
                    navigate(`/${emoji}`);
                }
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [data?.eid, dispatch, emojiID, navigate, params.yat, setEmojiId, setPageVersion]);

    if (isLoading) {
        return (
            <Navigation>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ maxWidth: 500, maxHeight: 500 }}>
                        <YatHandLoader />
                    </div>
                </div>
            </Navigation>
        );
    }

    return (
        <Navigation>
            <NoYatsError />
        </Navigation>
    );
}
